export default __webpack_public_path__ + "static/media/054-canary-islands.d812feb9.svg";